<template>
    <section class="block-diabetes-knowledge homepage section-space--lg">
        <div class="container">
            <header class="text-centered">
                <h4 class="new-headline-xlg">Lesen Sie mehr über Diabetes in unserem Ratgeber</h4>
                <p class="new-text-xl text-color-default">Interessieren Sie sich dafür, <strong><a href="https://vitadio.de/ratgeber/10-lebensmittel-die-bei-der-blutzuckerkontrolle-helfen-koennen/" target="_blank">was man bei Diabetes essen sollte</a></strong> oder <strong><a href="https://vitadio.de/ratgeber/arten-von-insulin/" target="_blank">wie sich Insulinarten unterscheiden</a></strong>? Mehr dazu und vieles mehr erfahren Sie in unserem Ratgeber.</p>
            </header>
            
            <div class="diabetes-knowledge-wrapper">
                <a v-for="(category, index) in categories" :key="index" :href="category.link" :target="openInNewWindow">
                    <figure :class="'category-img-'+category.id">
                        <img :src="category.image_id[0]" alt="">
                    </figure>

                    <div>
                        <h3 class="new-headline-sm" v-html="category.name"></h3>
                        <p class="new-text-md">{{ category.description }}</p>
                        <span>
                            <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.5 0.34375L8.5625 1.28125L11.625 4.34375H0.84375V5.65625H11.625L8.5625 8.71875L9.5 9.65625L14.1562 5L9.5 0.34375Z" fill="#5937B7" />
                            </svg>
                            Weiterlesen
                        </span>
                    </div>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {

        },
        data() {
            return {
                categories: []
            }
        },
        created() {
            this.fetchCategories()
        },
        computed: {
            openInNewWindow() {
                let uri = new URI(location.href)

                if(uri.domain() === 'abnehmenmitdiabetes.de') {
                    return '_blank'
                } else {
                    return '_self'
                }
            }
        },
        methods: {
            fetchCategories() {
                var instance = axios.create();
                delete instance.defaults.headers.common['X-CSRF-TOKEN']
                delete instance.defaults.headers.common['X-Requested-With']

                instance.get(`https://vitadio.de/ratgeber/wp-json/wp/v2/categories?parent=0`).then((r) => {
                    this.categories = r.data
                })
            }
        }
    }
</script>
